import moment from "moment";
import { useState } from "react";
import {
  handleApproveNarIngestion,
  handleDownload,
  handleRejectNarIngestion,
  retryNarIngestion,
  uploadClick,
} from "../actions";
import { getRenderActionButtons } from "../hooks/getRenderActionButtons";
import CardInfo from "./cardInfo";

interface GridCardProps {
  insurance: string;
  insurancePlan: string;
  createdOn: string;
  expiryDates: string;
  status: string;
  processedCsvPath?: string;
  outputFileName?: string;
  payerType: string;
  subType: string;
  month: number;
  year: number;
  documentType: string;
  documentId: string;
  isRejected?: boolean;
  sourceFileName?: string;
  effectiveDate?: string;
  neverExpire?: boolean;
}

const GridCard = ({
  insurance,
  insurancePlan,
  createdOn,
  expiryDates,
  status,
  processedCsvPath,
  outputFileName,
  payerType,
  subType,
  month,
  year,
  documentType,
  documentId,
  isRejected,
  sourceFileName,
  effectiveDate,
  neverExpire,
}: GridCardProps) => {
  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);

  const handleApprove = () => {
    handleApproveNarIngestion({
      payerType,
      subType,
      month,
      year,
      documentType,
      setIsSubmitting: setIsApproving,
      sourceFileName,
      effectiveDate,
      neverExpire,
    });
  };

  const handleReject = () => {
    handleRejectNarIngestion({
      documentId,
      setIsSubmitting: setIsRejecting,
    });
  };

  const handleUpload = () => {
    uploadClick(processedCsvPath);
  };

  const { renderActionButtons } = getRenderActionButtons({
    onApprove: handleApprove,
    onReject: handleReject,
    onUpload: handleUpload,
    onDownload: () => {
      if (processedCsvPath) {
        handleDownload(processedCsvPath, outputFileName);
      }
    },
    onRetry: retryNarIngestion,
    isApproving,
    isRejecting,
    isRejected,
  });

  const effectiveDateFormatted = effectiveDate
    ? moment(effectiveDate, "YYYY-MM-DD").format("MM/DD/YYYY")
    : "N/A";

  return (
    <div className="nar-configuration__grid-card flex h-full w-full flex-row justify-evenly rounded-md border-1 border-primaryGray-15 p-4">
      {/* left part */}
      <div className="flex w-[80%] flex-row justify-between">
        <CardInfo subHeading={"Insurance"} heading={insurance} />
        <CardInfo subHeading={"Insurance Plan"} heading={insurancePlan} />
        <CardInfo
          subHeading={"Effective Date"}
          heading={effectiveDateFormatted}
        />
        <CardInfo subHeading={"Created On"} heading={createdOn} />
        <CardInfo
          subHeading={"Expiry Dates"}
          heading={neverExpire ? "Never" : expiryDates}
        />
      </div>
      {/* right part */}
      <div className="flex w-[20%] flex-row items-center justify-end gap-3">
        {renderActionButtons(status)}
      </div>
    </div>
  );
};

export default GridCard;
